(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAmenityTemplateAddEditAmenity',
	};

	var form_id = 'reservationamenitytemplateaddeditamenity-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var note_fields = [
			'amount_notes',
			'notes',
			'client_notes',
		];

		// if amenity is set to "Other" display the text input to specify which
		$('#' + form_id + 'reservation_component_amenity_type_id').on('change', function _onChange(e)
		{
			var amenity = parseInt($(this).val());

			if (amenity === 10) { // Other
				$('#' + form_id + 'reservation_component_amenity_other_desc').val('');
				$('.other-amenity-desc').removeClass('hidden');
			} else {
				$('.other-amenity-desc').addClass('hidden');
			}
		});

		// show character counts for notes fields
		$.each(note_fields, function eachNoteField(i, field) {
			Adzuki.CharacterCount('#' + form_id + field, {
				max  : 100,
				label: '.' + field + '-count',
			});
		});
	};
}(jQuery, window.Adzuki || {}));
